function getNumberedEnv(host: string): string | null {
  const numberedEnv = host.match(/^dev\d{1,2}/);
  return numberedEnv?.length ? numberedEnv[0] : null;
}

function isHostNumberedEnv(host: string): boolean {
  return /^dev\d{1,2}/.test(host);
}

export const appVersion: string = "3.0.0-feature-ST-5411-Datagrid-pinned-hover.1";
export const appTimestamp: string = "2026-11-03T10:56:12.000Z";
export const commitId: string = "874613e683642e2f8beba1fa6338fb5f24a3c03e";
export const commitUrl: string = "https://dev.azure.com/faro-connect/Stellar/_git/AdminPanel/commit/874613e683642e2f8beba1fa6338fb5f24a3c03e?refName=refs%2Fheads%2Fmaster";
export const pullRequestId: string = "44662";
export const pullRequestUrl: string = "https://dev.azure.com/faro-connect/Stellar/_git/AdminPanel/pullrequest/44662";
export const jiraTicketId: string = "ST-5411";
export const jiraTicketUrl: string = "https://faro01.atlassian.net/browse/ST-5411";
export const muiProKey: string =
  "e750d7a2a7585a17ac2eaa4bc8a53c4aTz0xMTgwNzYsRT0xNzg3NjE1OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MTAsQVQ9bXVsdGksS1Y9Mg==";
export const amplitudeAPIKey: string = "32dbfd2d694789d6d7dd9b3a043784db";

export const sentryDsn =
  "https://a5f0e653e508490282b7d14d19443b9f@o381590.ingest.sentry.io/5580037";

export const isNumberedEnv = isHostNumberedEnv(globalThis.location.host);
export const numberedEnv = isNumberedEnv
  ? getNumberedEnv(globalThis.location.host)
  : null;
